<!-- 自主报考-> 报考信息 -->
<template>
  <div id="app_p">
    <div class="tbody" v-if="list.length">
      <div v-for="(ite, inde) in list" :key="inde" class="conent">
        <h4 class="titleH">
          {{ ite.name }}
        </h4>
        <van-row class="iconmin baseList" gutter="20">
          <van-col span="18">
            <span> 考试科目: </span>
            <span>{{ ite.subject }}</span>
          </van-col>
          <van-col span="6">
            <button class="btnicon but-green" v-if="ite.examStatus === 'draft'">
              草稿
            </button>
            <button
              class="btnicon but-orgin"
              v-if="ite.examStatus === 'auditing'"
            >
              审核中
            </button>
            <button
              class="btnicon but-red"
              v-if="ite.examStatus === 'rejected'"
            >
              已驳回
            </button>
            <button class="btnicon but-red" v-if="ite.examStatus === 'unPay'">
              待支付
            </button>
            <button class="btnicon but-blue" v-if="ite.examStatus === 'toTest'">
              待考试
            </button>
            <button class="btnicon but-gray" v-if="ite.examStatus === 'tested'">
              已考试
            </button>
            <button class="btnicon but-gray" v-if="ite.examStatus === 'miss'">
              未考试
            </button>
            <button
              class="btnicon but-gray"
              v-if="
                ite.examStatus === 'normal' || ite.examStatus === 'exception'
              "
            >
              考试中
            </button>
            <button
              class="btnicon but-gray"
              v-if="ite.examStatus === 'submitted'"
            >
              已考试
            </button>
            <button
              class="btnicon but-gray"
              v-if="ite.examStatus === 'invalidated'"
            >
              成绩作废
            </button>
            <button class="btnicon but-gray" v-if="ite.examStatus === 'undone'">
              已撤销
            </button>
            <button
              class="btnicon but-gray"
              v-if="ite.examStatus === 'tookNumber'"
            >
              已取号
            </button>
          </van-col>
        </van-row>
        <van-row class="baseList" gutter="20" v-if="ite.examaddress != null">
          <van-col span="20">
            <span> 理论考试地点: </span>
            <span>{{ ite.examaddress }}</span>
          </van-col>
        </van-row>
        <van-row class="baseList" gutter="20" v-if="ite.liveaddress != null">
          <van-col span="20">
            <span> 实操考试地点: </span>
            <span>{{ ite.liveaddress }}</span>
          </van-col>
        </van-row>
        <van-row class="baseList" gutter="20" v-if="ite.theTime != null">
          <van-col span="20">
            <span> 理论考试时间: </span>
            <span>{{ ite.theTime }}</span>
          </van-col>
        </van-row>
        <van-row class="baseList" gutter="20" v-if="ite.opeTime != null">
          <van-col span="20">
            <span> 实操考试时间: </span>
            <span>{{ ite.opeTime }}</span>
          </van-col>
        </van-row>
        <van-row
          v-if="ite.examStatus === 'rejected'"
          class="baseList"
          gutter="20"
        >
          <van-col span="20">
            <span> 驳回原因: </span>
            <span>{{ ite.down }}</span>
          </van-col>
        </van-row>

        <van-divider
          :style="{ margin: '0', borderColor: '#E8E8E8', padding: '0' }"
        />

        <van-row type="flex" class="timeRow">
          <van-col span="15">
            <span class="fillin_time" v-if="ite.examStatus === 'draft'">
              上次填写时间:{{
                $moment(ite.examDate).format("YYYY-MM-DD HH:mm:ss")
              }}
            </span>
          </van-col>
          <!-- <van-col span="15">
            <span class="fillin_time" v-if="ite.examStatus === '已驳回'"> 驳回原因:{{
                ite.down
            }} </span>
          </van-col> -->
          <van-col span="8">
            <div class="confirmButton">
              <van-button
                class="btn_public btn_right"
                v-if="ite.examStatus === 'draft'"
                @click="nextwrite(ite.examOrderId, ite.examStatus)"
                type="info"
                size="mini"
                block
                >继续填写</van-button
              >

              <van-button
                class="btn_public btn_left"
                v-if="ite.examStatus === 'unPay'"
                @click="occupation(ite.examOrderId, ite.examStatus)"
                type="info"
                size="mini"
                >前往支付</van-button
              >
              <van-button
                class="btn_public btn_left"
                v-if="ite.examStatus === 'rejected'"
                @click="editmodify(ite.examOrderId, ite.examStatus)"
                type="info"
                size="mini"
                >编辑修改</van-button
              >
              <!-- <van-button
                class="btn_public btn_left"
                v-if="ite.status == '1'"
                @click="
                  reschedule(ite.examOrderId, ite.examStatus, ite.subject)
                "
                type="info"
                size="mini"
                >重新预约</van-button
              > -->
              <van-button
                class="btn_right btn_public"
                v-if="ite.examStatus != 'draft'"
                @click="nextwrite(ite.examOrderId, ite.examStatus)"
                type="info"
                size="mini"
                >查看详情</van-button
              >
            </div>
          </van-col>
        </van-row>
      </div>

      <van-dialog
        v-model="rescheduleShow"
        title="提示"
        show-cancel-button
        confirm-button-text="确定"
        confirm-button-color="#54B0FB"
        overlay
        @confirm="rescheduleConfirm"
      >
        <p style="text-align: center; margin-top: 20px">确定要重新约考吗？</p>
        <span class="tintInfo"
          >(温馨提示 :
          考试当天不能进行重约,只能在今天下午六点以前重约。只能重约一次,请您慎重考虑！)</span
        >
      </van-dialog>
    </div>
    <div v-else>
      <van-empty description="您还没有报考信息" />
    </div>
  </div>
</template>
<script>
import { Dialog } from "vant";
export default {
  data() {
    return {
      list: [],
      array: [],
      examOrderIds: "", //  考试id
      subject: "", //科目
      rescheduleShow: false,
    };
  },
  computed: {
    currentUser: function () {
      return this.$store.state.session.user;
    },
  },
  created() {
    //localStorage.removeItem("examOrderId");
    this.showfirst();
  },
  methods: {
    //待考试的重新预约弹框确定按钮
    rescheduleConfirm(examOrderId, subject) {
      console.log("待考试预约的确定按钮", examOrderId, subject);
      this.$router.push({
        path: "/reschedule",
        query: { examOrderId: this.examOrderIds, subject: this.subject },
      });
    },
    //重新预约
    reschedule(examOrderId, status, subject) {
      console.log(examOrderId, status, subject);
      console.log(status);
      this.examOrderIds = examOrderId;
      this.subject = subject;
      if (status == "miss" ||status == "invalidated" || status.includes("miss")) {
        console.log("走进了未考试miss确定按钮了", examOrderId, status);
        this.$router.push({
          path: "/rescheduleNotTest",
          query: { examOrderId: examOrderId, status: status, subject: subject },
        });
      }
      //待考试的重新预约   需要弹窗的  是考试前一天
      if (status == "toTest" || status.includes("miss")) {
        console.log("走进了待考侍toTest的确定按钮了", examOrderId, status);
        this.rescheduleShow = true;
      }
    },
    editmodify(examOrderId) {
      this.$router.push({
        path: "reserve",
        query: { examOrderId: examOrderId, status: "rejected" },
      });
    },
    occupation(examOrderId) {
      const params = {
        examOrderId: examOrderId,
      };
      this.$http.post(`ExamOrder/findoccupation`, params).then((res) => {
        this.$router.push({
          path: "order_pinfo",
          query: { transOrder: res.data.data.orderId },
        });
      });
    },
    //请求参数
    showfirst() {
      this.$http.post(`ExamOrder/showOne`).then((res) => {
        console.log(res);
        if (res.status == "200" && res.data.success) {
          this.list = res.data.data.map((item) => {
            console.log(item.examStatus);
            item.examStatus = item.examStatus.join(",");
            return item;
          });
          console.log(this.list);
        }
        console.log("999999", res.data.data);
      });
    },
    nextwrite(examOrderId, status) {
      if (status == "auditing" || status == "unPay") {
        this.$router.push({
          path: "test_cxkq",
          query: { examOrderId: examOrderId },
        });
      }

      if (
        status == "toTest" ||
        status == "tested" ||
        status == "counted" ||
        status == "unTest"
      ) {
        this.$router.push({
          path: "test_cxkq2",
          query: { examOrderId: examOrderId },
        });
      } else if (status == "rejected" || status == "undone") {
        this.$router.push({
          path: "test_cxkq3",
          query: { examOrderId: examOrderId },
        });
      } else if (status == "invalidated") {
        this.$router.push({
          path: "resultsInvalid",
          query: { examOrderId: examOrderId },
        });
      }else if (status == "draft") {
        // console.log(res.data.data.list.id);
        this.$router.push({
          path: "reserve",
          query: { examOrderId: examOrderId },
        });
      } else {
        this.$router.push({
          path: "test_cxkq",
          query: { examOrderId: examOrderId },
        });
      }
      //   } else {
      //     alert(cw);
      //   }
      // });
    },
  },
};
</script>


<style lang="less" scoped>
#app_p {
  background-color: #eee;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 30px;
  width: 100%;
  height: 100vh;
}

#top {
  width: 100%;
  text-align: center;
  height: @headerh;
  box-sizing: border-box;
  padding-top: @headerpt;
  background-color: @backgroundcolor;
  padding-bottom: @headerpb;
}

.tbody {
  background-color: @backgroundcolor;
}

.rightcha {
  float: left;
}

.centerwz {
  /* display: block; */
  padding: 0px;
  font-size: 30px;
  line-height: 70px;
}

.conent {
  width: 750px;
  background-color: #fff;
  margin-bottom: 10px;

  .titleH {
    border-bottom: @allboxbordermin;
    height: @inputheight;
    line-height: @inputheight;
    padding-left: @paddingpay;
    margin-bottom: @paddingpay;
  }

  .row_footer {
    border-top: @allboxbordermin;
    height: @inputheight;
    line-height: @inputheight;
  }

  .time-but-position {
    position: relative;

    .position-time {
      position: absolute;
      left: 0;
      margin-left: 28px;
    }

    .position-but {
      position: absolute;
      right: 0;
      margin-right: 10px;

      &:nth-child(n) {
        margin-top: -10px;
      }
    }
  }
}

.conent2 {
  margin-top: 20px;
  height: 350px;
  background-color: #fff;
}

.iconmin {
  position: relative;

  .but-green {
    border-color: #24b726;
    color: #24b726;
  }

  .but-orgin {
    border-color: #e0721e;
    color: #e0721e;
  }

  .but-red {
    border-color: #e02020;
    color: #e02020;
  }

  .but-blue {
    border-color: #54b0fb;
    color: #54b0fb;
  }

  .but-gray {
    border-color: #999999;
    color: #999999;
  }
}
.baseList {
  margin: 16px 0px 15px 32px;
}
.timeRow {
  line-height: 100px;
  height: 100px;
  padding: 0 0 0 32px;
}
.btnradius {
  position: absolute;
  right: 0;
}

.btnicon {
  right: 30px;
  display: inline-block;
  width: 120px;
  height: 46px;
  background: white;
  border: 1px solid gainsboro;
  border-radius: @boxborder;
  color: gainsboro;
}

.checkmargin {
  margin-bottom: 15px;
}

.flexbuju {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.normer {
  margin-top: 30px;
}
.fillin_time {
  // display: inline-block;
  // margin-top: -10px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #797979;
  line-height: 10px;
  text-align: center;
}
.confirmButton {
  position: relative;
}
.btn_right {
  position: absolute;
  right: 10px;
  top: 20px;
}
.btn_left {
  position: absolute;
  right: 200px;
  top: 20px;
}
.btn_public {
  font-size: 24px;
  width: 156px;
  height: 64px;
}
button {
  font-size: 20px;
}

.van-overlay {
  background: red;
}
.tintInfo {
  display: block;
  margin: 20px auto;
  width: 569px;
  height: 152px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #e02020;
  line-height: 50px;
  text-align: center;
}
</style>
